// extracted by mini-css-extract-plugin
export var centerText = "_7s-8";
export var container = "_7s-0";
export var doughnutContainer = "_7s-7";
export var legend = "_7s-a";
export var legendItemColorDisplay = "_7s-b";
export var legendItemLabel = "_7s-d";
export var legendItemValue = "_7s-c";
export var lg = "_7s-5";
export var maxWidth = "_7s-9";
export var md = "_7s-4";
export var responsive = "_7s-6";
export var sm = "_7s-3";
export var xs = "_7s-2";
export var xxs = "_7s-1";